
























import Vue from 'vue'
import { ProductAddDTO, ProductUpdateDTO, ProductServiceProxy } from '@/service-proxies/app-v2/product.service-proxies'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import { isDisplayShow } from '@/utils'
const productServiceProxy = new ProductServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()
const crsp = new CodeRuleServiceProxy()
export default Vue.extend({
  name: 'CreateOrEditModal',
  props: {
    modalVisible: {
      type: Boolean,
      default: false
    },
    type: { // 新增or编辑
      type: String,
      default: 'add'
    },
    record: { // 产品详情
      type: Object,
      default: () => {
        return {}
      }
    },
    typeList: { // 产品类型列表
      type: Array,
      default: () => []
    },
    typeId: { // 当前选中的产品类型
      type: String,
      default: ''
    },
    columns: { // 动态表单项
      type: Array,
      default: () => []
    }
  },
  computed: {
    modalTitle() {
      return this.type === 'add' ? this.$t('page_product_add_product') : this.$t('page_product_edit_product')
    }
  },
  data() {
    return {
      schema: {},
      loading: false,
      productColums: [],
      productlist: [],
      showDisabled: false,
      datas: ''
    }
  },
  watch: {
    modalVisible(val) {
      
      if (val) {
        this.handleColumns(this.columns)
      }else {
        this.showDisabled = false
      }

    }
  },
  created(){
    this.getCodeRules()
  },
  methods: {
    // 获取指定业务的字段列表
    async getTableColumn(typeId) {
      this.productColums = []
      this.productColums = await tenantBizFieldServiceProxy.getTenantBizField('product', typeId)
      
      this.handleColumns(this.productColums)
    },
    async getCodeRules(){
      
      const res = await crsp.list('ProductObject')
      
      let arr = []
      arr = res
      for( const k of arr){
          this.productlist.push({
            label:k.name,
            value:k.id
          })
      }
      
    },
    handleColumns(columns) {
      if(this.type === 'add' && columns.length > 0) {
        if(columns.every(item =>item.code !== 'codeRuleId')){
          columns.unshift({
              bizCode: "product",
              code: "codeRuleId",
              id: "134883230536431267",
              isDisplay: 1,
              isRequired: 0,
              isSystem: 1,
              sort: 0,
              tip: "选择编码规则",
              title: "编码规则",
              type: 4
            })
        }
      }
      if(this.type === 'edit') {
        columns.map(item => {
          if(item.code === "codeRuleId" ){
            columns.shift(item)
          }
        })
      }
      this.schema = { properties: {}, required: [] }
      columns.map(item => {
        if (isDisplayShow(item.isDisplay, 1)) {
          if (item.code === 'typeId') {
            this.schema.properties[item.code] = {
              title: item.title,
              ui: {
                widget: 'select',
                placeholder: item.tip,
                requiredMessage: item.tip,
                showSearch:true,
                filterOption:function(input, option) {
                  return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }
              },
              default: this.typeId,
              enum: this.typeList
            }
            
          } else if(item.code === 'codeRuleId'){
            
              this.schema.properties[item.code] = {
              title: item.title,
              ui: {
                widget: 'select',
                placeholder: item.tip,
                requiredMessage: item.tip,
                allowClear: true,
                showSearch:true,
                filterOption:function(input, option) {
                  return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }
              },
              enum: this.productlist
            }
          }else {
            this.schema.properties[item.code] = {
              title: item.title,
              ui: {
                placeholder: item.tip,
                requiredMessage: item.tip
              }
            }
          }
          
          switch (item.code) {
            case 'name':
              break
            case 'code':
              this.schema.properties[item.code].readOnly = false
              break
            case 'codeRuleId':
              this.schema.properties[item.code].maxLength = 100
              break
            case 'suppier':
            case 'replaceSuppier':
            case 'materialCode':
            case 'replaceCodes':
            case 'stuff':
            case 'stuffStatus':
            case 'standardModel':
            case 'moldCode':
            case 'cutterCode':
              this.schema.properties[item.code].maxLength = 32
              break
            case 'unit':
              this.schema.properties[item.code].maxLength = 10
              break
            default:
              this.schema.properties[item.code].maxLength = 255
          }
          if (item.isRequired) {
            this.schema.required.push(item.code)
          }
        }
      })

      if (this.type === 'edit') {
        let val = this.record
        for (let key in this.schema.properties) {
          this.schema.properties[key].default = val[key]

          // 产品编号字段不允许编辑
          if(key==='code') {
            this.schema.properties[key].readOnly = true
          }
        }
      }
    },
    selectChange(data) {
      
      if(data.key==='typeId') {
        this.getTableColumn(data.value)
      }
      if(data.key === "codeRuleId"){
        if(data.value) {
          this.$refs.dForm.form.setFieldsValue({['code']:''})
            this.schema.required.map((item,index)=>{
              if(item === 'code'){
                 this.schema.required.splice(index,1)
              }
            })
            this.schema = {
            ...this.schema,
            properties: {
            ...this.schema.properties,
              code: {
                ...this.schema.properties.code,
                readOnly: true
              }
            },
          } 

        }else {
          this.schema.required.push('code')
            this.schema = {
          ...this.schema,
            properties: {
            ...this.schema.properties,
              code: {
                ...this.schema.properties.code,
                readOnly: false
              }
            }
          } 
        }
         
      }
    },
    handleSubmit() {
      const { form } = this.$refs.dForm
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.loading = true
            
            // 新增
            if (this.type === 'add') {
              this.typeList.map(item =>{
                if(item.value === values.typeId){
                  values.typeName = item.label
                }
              })
              await productServiceProxy.createProduct(new ProductAddDTO({ ...values }))
              this.$emit('close', {reload: true, selectedInit: true})
            } else {// 编辑
              await productServiceProxy.updateProduct(new ProductUpdateDTO({ ...values, id: this.record.id }))
              this.$emit('close', {reload: true, selectedInit: false})
            }

            this.loading = false
            // this.$emit('close', true)
            this.$message.success(this.$t('page_resource_pool_success'))
          } catch (e) {
            this.loading = false
          }
        }
      })
    },
    close() {
      this.$emit('close', {reload: false, selectedInit: false})
    }
  }
})
